import React, { useEffect } from "react";
import axios from "axios";
import { createBrowserHistory } from "history";

import List from "../features/List";

import { withRouter, useLocation } from "react-router-dom";
import * as Constants from "./Constants";

const baseUrl = Constants.URL();

function Newsletters() {
  const history = createBrowserHistory();

  var [newsletters, setNewsletters] = React.useState([]);
  var [isAdmin, setIsAdmin] = React.useState("");

  useEffect(() => {
    getAllNewsletters();
    fetchUsername();
  }, []);

  useEffect(() => {
    getSelectedFile();
  }, []);

  var getSelectedFile = () => {};

  const onNavigate = function () {
    const location = {
      pathname: "/UploadNewsletter",
      state: { fromDashboard: true },
    };

    history.push(location);
    window.location.reload();
  };

  var getAllNewsletters = () => {
    var data;
    axios
      .get(`${baseUrl}Newsletters/all`, {
        headers: {
          "Access-Control-Allow-Origin": true,
        },
      })
      .then((response) => {
        setNewsletters(response.data);
      });
  };

  const fetchUsername = async () => {
    try {
      const { data } = await axios.get(`${baseUrl}Auth/username`);
      setIsAdmin(data);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      {isAdmin && (
        <button className="Button" value="Unsubscribe" onClick={onNavigate}>
          Add Newsletter
        </button>
      )}
      <br />
      <div className="Card u-marginAuto u-marginBottom20">
        <div className="Card-content u-marginTop10">
          {newsletters.length > 0 ? (
            newsletters.map((data) => (
              <List
                Id={data.Id}
                CreatedDate={data.CreatedDate}
                Title={data.Title}
                IsAdmin={isAdmin}
              />
            ))
          ) : (
            <h3 className="center">Newsletters not found</h3>
          )}
          <hr />
        </div>
      </div>
    </div>
  );
}

export default withRouter(Newsletters);
